export default __webpack_public_path__ + "static/media/100_39339.e454775a.jpg";